export class DestinationDetails {
    MessageId: string;
    DestinationId: number;
    TimeOpened: Date;
    DispatchTime: Date;
    DestinationAddress: string;
    MessageLanguage: string;
    MessageSubject: string;
    MessageCategory: number;
    SenderAddress: string;
    ShortUrl: string;
    MessageCreatedDate: Date;
    TimeZoneOffset: number;
    MessageType: number;
    EMailDispatchOption: number;
    PhoneNumber: string;
    DestinationName: string;
    RequestsCount: number | null;
    RequestStatus: number | null;
    IsExpired: boolean;
    emailBody: string;
    ProtectedMsgShowAttachments: boolean;
    ProtectMsgReplyEnabled: boolean;
    ProtectMsgReplyCopyMeEnabled: boolean;
    ProtectMsgReplyLandingPage: string;
    IsSigned: number;
    EsignType: number;
    ProtectMsgReplyLimit: number;
    DeviceFingerprintSetting: boolean;
    DestinationType: number;
    IsProtectedReply: boolean;
      TTDT: string | null;  // ADD THIS

}
export class DestinationDetailsForProtectedText {
    DestinationDetails: DestinationDetails;
    EmailBody: string;
}